import { Injectable } from '@angular/core';
import { injectPaymentApi } from './payment-api';
import {
  AuthRequest, AuthResponse, CheckoutRequest, CheckoutResponse,
  PreauthRequest, PreauthResponse, RedirectRequest, RedirectResponse
} from './payment-api.models';


@Injectable({ providedIn: 'root' })
export class PaymentService {
  private paymentApi = injectPaymentApi();

  /**
   * Initialises a checkout transaction and returns the transaction data.
   * @param data Checkout request payload.
   */
  paymentCheckout(data: CheckoutRequest): Promise<CheckoutResponse> {
    return this.paymentApi.checkout(data);
  }

  /**
   * Requests a payment redirect (Redsys hosted-page flow).
   * @param data Redirect request payload.
   */
  paymentRedirect(data: RedirectRequest): Promise<RedirectResponse> {
    return this.paymentApi.redirect(data);
  }

  /**
   * Performs the 3DS pre-authorisation step (step 1).
   * @param data Pre-auth request payload.
   */
  paymentPreAuth(data: PreauthRequest): Promise<PreauthResponse> {
    return this.paymentApi.preAuth(data);
  }

  /**
   * Completes the 3DS authorisation step (step 2).
   * @param data Auth request payload.
   */
  paymentAuth(data: AuthRequest): Promise<AuthResponse> {
    return this.paymentApi.auth(data);
  }
}
